import { Badge } from "@/components/ui/badge"
import { FEEDBACK_STATUSES, type FeedbackStatus } from "@/types/feedback"

const TONES = { not_reviewed: "signal", reviewing: "accent", completed: "muted" } as const

export function FeedbackStatusBadge({ status }: { status: FeedbackStatus }) {
  const label = FEEDBACK_STATUSES.find((s) => s.value === status)?.label ?? status
  return <Badge tone={TONES[status]}>{label}</Badge>
}
